import React from 'react'
import { useTranslation } from 'react-i18next'

import { useColumnToggle } from '../../../../hooks/useColumnToggle'
import { ConfigurableTable, convertOrder } from '../../../../utils/wrapper'
import { useOrders } from '../../../order/data'
import { useConfigContext } from '../../../ui-config/context'

const TOGGLEABLE_FIELDS = [
  'Payload.OrderDate',
  'Payload.OrderDeliveryDate',
  'Payload.InvoiceAmount',
  'Payload.Currency',
]

const STORAGE_KEY = 'orders-order-response-visible-columns'

type Props = {
  globalFilterValue: string
  setGlobalFilterValue: (value: string) => void
  isVisible: boolean
}

export const OrdersTable: React.FC<Props> = ({
  globalFilterValue,
  setGlobalFilterValue,
  isVisible,
}) => {
  const { t } = useTranslation()

  const { data: orders, isLoading } = useOrders()
  const { uiConfig: config } = useConfigContext()

  const tableConfig = config.orders.orderResponse.table
  const { effectiveTableConfig, navigationColumnHeader } = useColumnToggle(
    tableConfig,
    TOGGLEABLE_FIELDS,
    STORAGE_KEY,
  )

  return (
    <div hidden={!isVisible && (orders === undefined || orders.length === 0)}>
      {config.orders.orderResponse.enabled && (
        <div className="mt-0">
          <h3>{t('orders.orderResponse.title')}</h3>

          <ConfigurableTable
            config={effectiveTableConfig}
            data={convertOrder(orders)}
            link="orders/order"
            globalFilterFields={['Payload.OrderId']}
            globalFilterValue={globalFilterValue}
            setGlobalFilterValue={setGlobalFilterValue}
            isLoading={isLoading}
            stateKey="table-orders"
            navigationColumnHeader={navigationColumnHeader}
          />
        </div>
      )}
    </div>
  )
}
